<template>
    <navbar btn-background="bg-gradient-success" />

    <main class="mt-0 main-content">
        <div class="page-header align-items-start min-vh-50 m-3 border-radius-lg" 
         :style="{
           backgroundImage: 'url(' + require('@/assets/img/adam_bot.jpg') + ')',
           backgroundSize: 'cover',
           backgroundPosition: 'center',
           backgroundRepeat: 'no-repeat'
         }">
            <span class="mask bg-gradient-dark opacity-6"></span>
        </div>
        <section>
            <div class="container mb-4">
                <div class="row mt-lg-n12 mt-md-n12 mt-n12 justify-content-center">
                    <div class="col-xl-6 col-lg-7 col-md-8 mx-auto">
                        <div class="card mt-8">
                            <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                <div class="bg-gradient-success shadow-success border-radius-lg py-3 pe-1 text-center py-4">
                                    <h3 class="font-weight-bolder text-white">Registrierung starten</h3>
                                    <p style="color: white;">Geben Sie Ihre E-Mail-Adresse ein, um einen Registrierungslink zu erhalten</p>
                                </div>
                            </div>
                            <div class="py-4 card-body">

                                <!-- Success State -->
                                <div v-if="linkSent" class="text-center py-4">
                                    <div class="text-success mb-3">
                                        <i class="fas fa-check-circle fa-4x"></i>
                                    </div>
                                    <h4 class="text-success">Registrierungslink versendet!</h4>
                                    <p class="text-muted mb-4">
                                        Ein Registrierungslink wurde an <strong>{{ email }}</strong> gesendet.
                                        <br>Der Link ist 2 Stunden gültig.
                                    </p>
                                    <div class="alert alert-info">
                                        <i class="fas fa-info-circle me-2"></i>
                                        Bitte prüfen Sie auch Ihren Spam-Ordner und klicken Sie auf den Link in der E-Mail, um Ihre Registrierung abzuschließen.
                                    </div>
                                    <div class="mt-4">
                                        <material-button variant="outline" color="success" @click="resetForm">
                                            Weitere E-Mail senden
                                        </material-button>
                                    </div>
                                </div>

                                <!-- Request Form -->
                                <Form v-else role="form" :validation-schema="schema" @submit="sendRegistrationLink">
                                    <div class="mb-4">
                                        <h6>Willkommen bei Adam AI!</h6>
                                        <p class="text-muted small">
                                            Um die Sicherheit zu gewährleisten, senden wir Ihnen einen persönlichen Registrierungslink. 
                                            Geben Sie Ihre E-Mail-Adresse ein, um zu beginnen.
                                        </p>
                                    </div>

                                    <div class="mb-3">
                                        <material-input-field 
                                            id="email" 
                                            v-model:value="email" 
                                            type="email"
                                            label="E-Mail-Adresse" 
                                            placeholder="ihre.email@beispiel.de" 
                                            name="email" 
                                            variant="static" />
                                    </div>

                                    <div class="text-center">
                                        <material-button 
                                            class="mt-4" 
                                            variant="gradient" 
                                            color="success"
                                            full-width
                                            :disabled="isSubmitting">
                                            <span v-if="isSubmitting">
                                                <i class="fas fa-spinner fa-spin me-2"></i>
                                                Registrierungslink wird versendet...
                                            </span>
                                            <span v-else>
                                                <i class="fas fa-paper-plane me-2"></i>
                                                Registrierungslink senden
                                            </span>
                                        </material-button>
                                    </div>

                                    <div class="text-center mt-4">
                                        <p class="text-sm">
                                            Haben Sie bereits ein Konto?
                                            <router-link :to="{ name: 'Login' }" class="text-success text-gradient font-weight-bold">
                                                Zur Anmeldung
                                            </router-link>
                                        </p>
                                    </div>
                                    
                                    <div class="text-center mt-3">
                                        <small class="text-muted">
                                            Mit der Registrierung stimmen Sie unseren 
                                            <a href="#" class="text-success">AGB</a> und der 
                                            <a href="#" class="text-success">Datenschutzerklärung</a> zu.
                                        </small>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
    <app-footer />
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import * as Yup from 'yup'
const body = document.getElementsByTagName("body")[0];
import { Form } from "vee-validate";
import showSwal from "@/mixins/showSwal";
import backgroundImage from '@/assets/img/adam_bot.jpg';
import axios from 'axios';
import { mapMutations } from "vuex";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    name: "Signup",
    components: {
        Navbar,
        AppFooter,
        MaterialInputField,
        MaterialButton,
        Form
    },
    data() {
        return {
            imageUrl: backgroundImage,
            email: '',
            isSubmitting: false,
            linkSent: false,
            
            schema: Yup.object().shape({
                email: Yup.string()
                    .email("E-Mail-Adresse muss gültig sein")
                    .required("E-Mail-Adresse ist erforderlich")
            }),
        }
    },
    
    beforeMount() {
        this.toggleEveryDisplay();     // ← 🎯 VERSTECKT die Sidebar
        this.toggleHideConfig();       // ← 🎯 VERSTECKT weitere UI-Elemente
        body.classList.remove("bg-gray-100");
    },
    
    beforeUnmount() {
        this.toggleEveryDisplay();     // ← 🎯 ZEIGT Sidebar wieder an
        this.toggleHideConfig();       // ← 🎯 ZEIGT weitere UI-Elemente wieder an
        body.classList.add("bg-gray-100");
    },
    
    methods: {
        ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
        async sendRegistrationLink() {
            if (this.isSubmitting) return;

            try {
                this.isSubmitting = true;

                const response = await axios.post(`${API_URL}/register?action=request-link`, {
                    email: this.email
                }, {
                    headers: {
                        Accept: "application/vnd.api+json",
                        "Content-Type": "application/vnd.api+json",
                    }
                });
                
                console.log('Registration link sent:', response.data);
                
                this.linkSent = true;
                
            } catch (error) {
                console.error('Send registration link error:', error);
                
                const errorMessage = error.response?.data?.error || 
                                   "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.";
                
                showSwal.methods.showSwal({
                    type: "error",
                    message: errorMessage,
                    width: 500
                });
                
            } finally {
                this.isSubmitting = false;
            }
        },

        resetForm() {
            this.email = '';
            this.linkSent = false;
        }
    }
};
</script>

<style scoped>
.fa-4x {
    font-size: 4rem;
}

.fa-spin {
    animation: fa-spin 2s infinite linear;
}

@keyframes fa-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.alert-info {
    background-color: #e3f2fd;
    border-color: #bbdefb;
    color: #1565c0;
    border-radius: 8px;
}
</style>